import { logging, utils } from '@heimdall/core-common';
var logger = logging.instantiateLogger('heimdall:core:domain:user:codec');
import { User } from './models';
export var UserCodec = utils.CodecUtils.generateCodec(logger)(User)(User.is);